import { Component, inject, signal } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { UpperCasePipe } from '@angular/common';
import { SharedUiModule } from '@nx-customer-apps/shared/ui';
import { CountryLanguagePairs, LanguageCountryDictionary } from '../../consts';
import { LanguageSwitcherService } from '../../services';

@Component({
    selector: 'app-language-switcher',
    templateUrl: './language-switcher.component.html',
    styleUrls: ['./language-switcher.component.scss'],
    imports: [MatButton, MatMenuTrigger, MatIcon, MatMenu, MatMenuItem, UpperCasePipe, TranslatePipe, SharedUiModule]
})
export class LanguageSwitcherComponent {
    protected languageSwitcherService = inject(LanguageSwitcherService);
    countryLanguagePairs = CountryLanguagePairs;
    languageCountryType = LanguageCountryDictionary;
    chevronIcon = signal<'expand_more' | 'expand_less'>('expand_more');

    currentLocale = this.languageSwitcherService.getCurrentLocale();
}
